import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-7b33104a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "notice-content"
};
var _hoisted_2 = {
  class: "notice-floor"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "content"
  }, [/*#__PURE__*/_createElementVNode("p", null, " 为确保线上答题顺利进行，请您仔细阅读以下赛区须知，并在确认已知晓并同意所有条款后开始答题。 ")], -1);
});
var _hoisted_5 = {
  class: "notice-floor"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "考试信息", -1);
});
var _hoisted_7 = {
  class: "content"
};
var _hoisted_8 = {
  class: "info-order-list"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "bold"
  }, "考核内容：", -1);
});
var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 本次考试包含 ");
var _hoisted_11 = {
  class: "hl"
};
var _hoisted_12 = /*#__PURE__*/_createTextVNode(" ； ");
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "bold"
  }, "答题机会与时间限制：", -1);
});
var _hoisted_14 = /*#__PURE__*/_createTextVNode(" 每位选手仅有");
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "hl"
  }, "1", -1);
});
var _hoisted_16 = /*#__PURE__*/_createTextVNode("次答题机会， ");
var _hoisted_17 = {
  class: "underline"
};
var _hoisted_18 = /*#__PURE__*/_createTextVNode(" 超时自动提交； ");
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "bold"
  }, "浏览器要求："), /*#__PURE__*/_createTextVNode(" 请使用最新版本"), /*#__PURE__*/_createElementVNode("span", {
    class: "hl"
  }, "（至少80.0以上）"), /*#__PURE__*/_createTextVNode("的Chrome浏览器访问考试系统。 ")], -1);
});
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "bold"
  }, "设备要求"), /*#__PURE__*/_createElementVNode("ol", {
    class: "cont-order-list"
  }, [/*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createTextVNode(" 操作系统： "), /*#__PURE__*/_createElementVNode("span", {
    class: "underline"
  }, "建议使用Windows 7及以上版本"), /*#__PURE__*/_createTextVNode(" ； ")]), /*#__PURE__*/_createElementVNode("li", null, "内存：8G以上；"), /*#__PURE__*/_createElementVNode("li", null, "CPU：建议酷睿i5以上；"), /*#__PURE__*/_createElementVNode("li", null, "硬盘空间：C盘（或系统盘）需有4G以上剩余空间；"), /*#__PURE__*/_createElementVNode("li", null, " 硬件设备：需配备摄像头、音箱或耳机、麦克风，建议使用含摄像头的笔记本电脑及耳麦。 ")])], -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "bold"
  }, "网络与环境："), /*#__PURE__*/_createTextVNode(" 请确保网络环境稳定，并在正式考试前关闭QQ、微信等即时通信软件。考试过程中请勿跳出考试页面。 ")], -1);
});
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "bold"
  }, "系统操作："), /*#__PURE__*/_createTextVNode(" 登录后，请按系统提示熟悉操作流程，并检查网络及浏览器是否正常运行。 ")], -1);
});
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "bold"
  }, "答题与交卷"), /*#__PURE__*/_createTextVNode(" 请在规定时间内完成所有题目。考试时间结束时，无论是否答完，系统将自动提交答卷。 ")], -1);
});
var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "bold"
  }, "异常处理"), /*#__PURE__*/_createTextVNode(" 如因电源、网络故障等原因导致考试中断，请尽快重新登录， "), /*#__PURE__*/_createElementVNode("span", {
    class: "underline"
  }, "系统将保存您的答题进度"), /*#__PURE__*/_createTextVNode(" 。 ")], -1);
});
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "bold"
  }, "考场纪律："), /*#__PURE__*/_createTextVNode(" 请诚信答题，自觉服从相关工作人员的管理。不得以任何理由妨碍监考员履行职责，不得扰乱考试秩序。如发现违纪、作弊等行为，将按照无成绩记录处理。 ")], -1);
});
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "tips"
  }, " 我已仔细阅读并理解上述考前须知，知晓考试规则及相关要求，并承诺遵守考试纪律，诚信参加考试。 ", -1);
});
var _hoisted_27 = {
  class: "footer"
};
var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "footer-tips"
  }, " 如您已确认以上内容，请点击“我已知晓，开始答题”按钮进入答题页面。 ", -1);
});
var _hoisted_29 = {
  class: "action-area"
};
var _hoisted_30 = /*#__PURE__*/_createTextVNode("暂不答题");
var _hoisted_31 = /*#__PURE__*/_createTextVNode(" 我已知晓，开始答题 ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_spin = _resolveComponent("a-spin");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    width: "800px",
    visible: _ctx.data.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.data.visible = $event;
    }),
    title: _ctx.data.commitmentLetterTitle || '比赛须知',
    "mask-closable": false
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, [_createVNode(_component_a_button, {
        onClick: _ctx.onClose
      }, {
        default: _withCtx(function () {
          return [_hoisted_30];
        }),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.onStartExamButtonClick
      }, {
        default: _withCtx(function () {
          return [_hoisted_31];
        }),
        _: 1
      }, 8, ["onClick"])])])];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_a_spin, {
        size: "large",
        tip: "正在加载数据中...",
        spinning: _ctx.loading,
        delay: 200
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, "参赛选手" + _toDisplayString(_ctx.data.userName) + "：", 1), _hoisted_4]), _createElementVNode("section", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createElementVNode("ol", _hoisted_8, [_createElementVNode("li", null, [_hoisted_9, _hoisted_10, _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.data.baseInfoText), 1), _hoisted_12]), _createElementVNode("li", null, [_hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.data.answerRule), 1), _hoisted_18]), _hoisted_19, _hoisted_20, _hoisted_21, _hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25]), _hoisted_26])])])];
        }),
        _: 1
      }, 8, ["spinning"])];
    }),
    _: 1
  }, 8, ["visible", "title"]);
}